import {Outlet} from "react-router-dom";



const GameLayout = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default GameLayout;
